import React from 'react';
import STRINGS from './../../data/language/language';
import Random from "../../utils/strings/Random";

class Objetivo extends React.Component{
  constructor (props){
    super(props);
    this.state = {
      wrapper:Random(7),
      strings:STRINGS[window.LANGUAGE]
    }

  }

  componentDidMount() {
  }

  componentWillUnmount() {

  }

  render (){
    return (
      <div className='box-objetivos'>
        <p>Caso você esteja acima do peso, eu sugiro que você escolha o treino de emagrecimento.</p>
<p>Caso você queira aumentar a massa muscular e está em dúvida por estar com alguns quilinhos a mais, você pode escolher qualquer das opções. Pense o que você quer priorizar em 90 dias. Como você prefere estar em 90 dias?<br /><br />
1 - Mais definida e tonificada (escolha emagrecimento);<br />
2 - Com mais volume muscular, mesmo que ainda com as gordurinhas (escolha hipertrofia).</p>
<p>Caso você tenha muito pouca massa muscular e ainda assim sente que tem muita gordura localizada, faça os primeiros 90 dias com treino de hipertrofia.</p>
<p>Caso você seja magra e tenha dificuldade em ganhar massa muscular, mantenha seu Foco em Hipertrofia durante o ano todo e, só depois de alcançar um ótimo resultado, experimente buscar a definição muscular usando o treino de emagrecimento e definição, juntamente com uma nutrição adequada.</p>
<p>É muito importante que você saiba que o treino de musculação do Foco90 vai fazer você melhorar o tônus muscular e até aumentar os músculos, mesmo que você use o treino e orientação nutricional de emagrecimento/definição.</p>
      </div>
    );
  }
}

export default Objetivo;



// WEBPACK FOOTER //
// ./src/classes/perfil/Objetivo.js